import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({ name, altText, ...props}) => (
  <svg {...props}>
    <title>{altText}</title>
    <use xlinkHref={`#${name}`}/>
  </svg>
);

Svg.propTypes = {
  name: PropTypes.string.isRequired,
  altText: PropTypes.string
}

export default Svg;
